var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CustomerForm',{attrs:{"customer":_vm.customer,"formType":_vm.type,"buttonLoading":_vm.buttonLoading,"overlay":_vm.overlay},on:{"saveCustomer":_vm.updateCustomer}})
}
var staticRenderFns = []

export { render, staticRenderFns }